<div class="action-success-popup">
    <div class="header">
        <img src="assets/circle-right.svg" alt="Confirm" />
    </div>
    <div class="body">
        <div class="content">{{ data.message }}</div>
        <button mat-raised-button color="primary" (click)="dialogRef.close()">Done</button>
    </div>
</div>
